import { HttpClient } from '@wix/http-client'

export const reportError = (error: Error, tags?: Record<string, string>) => {
  if (window.__USE_PANORAMA__ === 'true') {
    const { panoramaClient } = require('./panorama') as typeof import('./panorama')
    panoramaClient.errorMonitor().reportError(error, { tags })
    return
  }

  const extra: Record<string, unknown> = {}
  if (HttpClient.isHttpError(error)) {
    extra.requestId = error.requestId

    // This thing exists to fix axioses' ugly async stacktraces by providing cool ones
    error.stack = new Error().stack
  }

  if (window.__DEBUG__ === 'true') {
    console.error(error)
  }
  window.Sentry.captureException(error, { extra, tags })
}
